(function ($) {
    $(function () {

        /*****
            Fancybox
            ---
            This is just sample code, to be extended
        *****/
        $().fancybox({
            selector: '.video-lightbox, .photo-lightbox',
            hash: false,
            buttons: ['close'],
            infobar: false,
            idleTime: 300,
            loop: true,
            btnTpl: {
                close:
                    '<button data-fancybox-close class="fancybox-button fancybox-button--close" title="{{CLOSE}}">' + return_svg('close') + '</button>',
                arrowLeft:
                    '<button data-fancybox-prev class="fancybox-button fancybox-button--arrow_left" title="{{PREV}}">' +
                    return_svg('chev_down') +
                    "</button>",
                arrowRight:
                    '<button data-fancybox-next class="fancybox-button fancybox-button--arrow_right" title="{{NEXT}}">' +
                    return_svg('chev_down') +
                    "</button>",
            },
            beforeShow: function () {
                $('.fancybox-content .lightbox-custom-caption').remove();
            },
            afterShow: function (instance, slide) {
                const fancytitle = instance.current.opts.fancytitle || false;
                const fancysubtitle = instance.current.opts.fancysubtitle || false;
                const fancycaption = instance.current.opts.fancycaption || false;
                const fancydownloadtitle = instance.current.opts.fancydownloadtitle || false;
                const fancydownloadurl = instance.current.opts.fancydownloadurl || false;

                if (fancytitle || fancysubtitle || fancycaption || fancydownloadtitle || fancydownloadurl) {
                    $('.fancybox-content').append('<div class="lightbox-custom-caption"></div>');

                    if (fancysubtitle) {
                        $('.lightbox-custom-caption').append('<p class="lightbox-subtitle">' + fancysubtitle + '</p>');
                    }

                    if (fancytitle) {
                        $('.lightbox-custom-caption').append('<h3 class="lightbox-title">' + fancytitle + '</h3>');
                    }

                    if (fancycaption) {
                        $('.lightbox-custom-caption').append('<p class="lightbox-caption">' + fancycaption + '</p>');
                    }

                    if (fancydownloadtitle || fancydownloadurl) {
                        $('.lightbox-custom-caption').append('<p class="lightbox-download"><a class="btn btn__primary" target="_blank" href="' + fancydownloadurl + '">' + fancydownloadtitle + '<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none"><path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5" d="M17.25 8.25 21 12m0 0-3.75 3.75M21 12H3"/></svg></a></p>');
                    }
                }
            }
        });

    });
})(jQuery);
